// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1NJoN","boxWrapper":"_1nT7Q"};